export default __webpack_public_path__ + "static/media/common_intel.6e0db4d2.png";